import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1251.65412,0 C1296.15294,0 1339.86118,18.0705882 1371.37176,49.5811765 L1371.37176,49.5811765 L1700.59529,378.804706 C1732.55765,410.767059 1750.17647,453.345882 1750.17647,498.522353 L1750.17647,498.522353 L1750.17647,1920 L169,1920 L169,0 Z M1185.47059,112.941176 L281.941176,112.941176 L281.941176,1807.05882 L1637.23529,1807.05882 L1637.23529,564.705882 L1185.47059,564.705882 L1185.47059,112.941176 Z M1298.41176,136.32 L1298.41176,451.764706 L1613.85647,451.764706 L1298.41176,136.32 Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M959.588235 338.823529L959.588235 790.588235 507.823529 790.588235 507.823529 338.823529 959.588235 338.823529zM846.647059 451.764706L620.764706 451.764706 620.764706 677.647059 846.647059 677.647059 846.647059 451.764706zM507.823529 1016.47059L1411.35294 1016.47059 1411.35294 903.529412 507.823529 903.529412zM507.823529 1468.23529L1298.41176 1468.23529 1298.41176 1355.29412 507.823529 1355.29412zM507.823529 1242.35294L1185.47059 1242.35294 1185.47059 1129.41176 507.823529 1129.41176z"
}));

var IconMsWordLine = /*#__PURE__*/function (_Component) {
  _inherits(IconMsWordLine, _Component);

  var _super = _createSuper(IconMsWordLine);

  function IconMsWordLine() {
    _classCallCheck(this, IconMsWordLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconMsWordLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconMsWord",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconMsWordLine.displayName = "IconMsWordLine";
  return IconMsWordLine;
}(Component);

IconMsWordLine.glyphName = 'ms-word';
IconMsWordLine.variant = 'Line';
IconMsWordLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconMsWordLine;
export { IconMsWordLine };